import { render, staticRenderFns } from "./xiche.vue?vue&type=template&id=88238e66"
import script from "./xiche.vue?vue&type=script&lang=js"
export * from "./xiche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports